import { React, useEffect, useRef, useState } from "react";

const DonutAnimation = () => {
  const preRef = useRef();
  const [dimensions, setDimensions] = useState({ width: 80, height: 22 });

  // Update dimensions based on window size
  useEffect(() => {
    const updateDimensions = () => {
      const width = Math.floor(window.innerWidth / 10); // 10px per character
      const height = Math.floor(window.innerHeight / 18); // 18px per line
      setDimensions({ width, height });
    };
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  useEffect(() => {
    let z = 0;
    let y = 0;
    const interval = setInterval(() => {
      const { width, height } = dimensions;
      const x = width * height;

      const a = Array(x)
        .fill(" ")
        .map((_, r) => ((r + 1) % width === 0 ? "\n" : " "));

      const r = Array(x).fill(0);

      const t = Math.cos(z);
      const e = Math.sin(z);
      const n = Math.cos(y);
      const o = Math.sin(y);

      for (let s = 0; s < 6.28; s += 0.07) {
        const c = Math.cos(s);
        const h = Math.sin(s);

        for (let s2 = 0; s2 < 6.28; s2 += 0.02) {
          const v = Math.sin(s2);
          const M = Math.cos(s2);
          const i = c + 2;
          const l = 1 / (v * i * e + h * t + 5);
          const p = v * i * t - h * e;
          const d = Math.floor(width / 2 + width / 2 * l * (M * i * n - p * o));
          const m = Math.floor(height / 2 + height / 2 * l * (M * i * o + p * n));
          const f = Math.floor(8 * ((h * e - v * c * t) * n - v * c * e - h * t - M * c * o));
          const index = d + width * m;

          if (m >= 0 && m < height && d >= 0 && d < width && l > r[index]) {
            r[index] = l;
            a[index] = ".,-~:;=!*#$@"[f > 0 ? f : 0];
          }

        }
      }

      if (preRef.current) {
        preRef.current.textContent = a.join("");
      }
      z += 0.07;
      y += 0.03;
    }, 50);

    return () => clearInterval(interval);
  }, [dimensions]);

  return (
    <div
      className="donut-background"
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        color: "white",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "monospace",
        whiteSpace: "pre",
        overflow: "hidden",
        zIndex: 1,
        opacity: 0.3,
      }}
    >
      <pre ref={preRef}></pre>
    </div>
  );
};

export default DonutAnimation;